export default "__VITE_ASSET__645450fa__"